/* ============================================================================
   Kalea — custom theme JS (countdown, scroll-reveal, reliable #fragment
   scrolling, quick keyword search, mobile drawer, wordmark slide-up).
   Ported as-is from the standalone Kalea website; only the search routes
   below were changed to point at real Shopify URLs (/collections/..,
   /pages/.., /#anchor) instead of the old .html file names.
   ============================================================================ */

(function(){
  var yearEl = document.getElementById('year');
  if(yearEl){ yearEl.textContent = new Date().getFullYear(); }

  // Marks the sticky header as "docked" only once it has actually scrolled up
  // against the top of the page (i.e. the utility bar above it has scrolled
  // out of view) — used to cover an iOS Safari rendering gap near the Dynamic
  // Island only while the header is stuck, without also covering the marquee
  // bar at the very top of the page before any scrolling happens.
  var stickyHeader = document.querySelector('header.main-nav');
  var utilityBar = document.querySelector('.utility-bar');
  if(stickyHeader && utilityBar && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      stickyHeader.classList.toggle('header-stuck', !entries[0].isIntersecting);
    }, {threshold: 0}).observe(utilityBar);
  }

  // Countdown to next drop — the target date comes from the "Nächster Drop"
  // theme setting (data-target on #countdown), set in the Theme Editor.
  // Only runs on pages that have it.
  var elDays = document.getElementById('cd-days');
  if(elDays){
    var countdownEl = document.getElementById('countdown');
    var targetIso = countdownEl && countdownEl.dataset.target;
    var target = targetIso ? new Date(targetIso).getTime() : new Date('2026-10-17T18:00:00+02:00').getTime();
    if(isNaN(target)){ target = new Date('2026-10-17T18:00:00+02:00').getTime(); }
    var els = {
      d: elDays,
      h: document.getElementById('cd-hours'),
      m: document.getElementById('cd-mins'),
      s: document.getElementById('cd-secs')
    };
    var pad = function(n){ return String(n).padStart(2,'0'); };
    var tick = function(){
      var now = Date.now();
      var diff = Math.max(0, target - now);
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      els.d.textContent = pad(days);
      els.h.textContent = pad(hours);
      els.m.textContent = pad(mins);
      els.s.textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);
  }

  // Scroll reveal for cards, steps, panels and the waitlist banner.
  // Content is visible by default in CSS; only add "js-ready" (which arms the
  // fade-in) once we get this far, and only once IntersectionObserver actually
  // exists and reduced-motion isn't requested — otherwise leave everything visible.
  var revealEls = document.querySelectorAll('.reveal');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(revealEls.length && 'IntersectionObserver' in window && !reduceMotion){
    document.documentElement.classList.add('js-ready');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:.15, rootMargin:'0px 0px -40px 0px'});
    revealEls.forEach(function(el){ io.observe(el); });
  }
})();

// Reliable #fragment scrolling: the browser's native "jump to the target on load" turned out
// to be unreliable on a real cross-page click-through (confirmed by repeated testing — it
// sometimes silently didn't scroll at all), and doesn't know about the sticky header's height
// either way. This explicitly (re)scrolls to the current fragment once the page has settled,
// clearing the header, and also covers same-page fragment clicks via "hashchange".
(function(){
  function scrollToHash(){
    var hash = window.location.hash;
    if(!hash || hash.length < 2) return;
    var id = hash.slice(1);
    var target;
    try{ target = document.getElementById(decodeURIComponent(id)); } catch(e){ target = document.getElementById(id); }
    if(!target) return;
    if(target.classList && target.classList.contains('swatch-btn') && typeof window.kaleaSwitchCollarColor === 'function'){
      window.kaleaSwitchCollarColor(target);
      // Scroll to the top of the photo gallery, not the swatch button itself — the
      // button sits below the images, so scrolling straight to it (especially on
      // mobile, where everything stacks vertically) skipped the photos entirely.
      var card = target.closest('.card');
      var gallery = card && card.querySelector('.feature-gallery');
      if(gallery) target = gallery;
    }
    var header = document.querySelector('header.main-nav');
    var offset = (header ? header.offsetHeight : 0) + 20;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({top: Math.max(0, y), left: 0, behavior: 'auto'});
  }
  function scrollToHashSettled(){
    scrollToHash();
    // Mobile Safari in particular can still perform its own native jump to the
    // fragment target AFTER "load" has fired (e.g. once a lazy-loaded image
    // above finishes and shifts the layout) — a second, slightly delayed pass
    // catches and corrects that late jump instead of leaving the page resting
    // on Dawn's/the browser's own position.
    setTimeout(scrollToHash, 350);
  }
  if(document.readyState === 'complete'){ scrollToHashSettled(); }
  else { window.addEventListener('load', scrollToHashSettled); }
  window.addEventListener('hashchange', scrollToHash);
})();

// Kalea No. I: one card, one photo stack per colourway — a swatch click swaps which
// colour's whole photo stack is shown (the other colour's photos are hidden entirely),
// plus updates the title/accent-leather value. Also reachable directly via the header's
// "Halsbänder" links (#swatch-orange/#swatch-blau), which the hash handler above resolves
// to a click here, so the right colour's photos are already showing when the page settles.
window.kaleaSwitchCollarColor = function(btn){
  if(!btn) return;
  var picker = btn.closest('.swatch-picker');
  var card = btn.closest('.card');
  if(!picker || !card || btn.classList.contains('active')) return;

  picker.querySelectorAll('.swatch-btn').forEach(function(b){
    b.classList.remove('active');
    b.setAttribute('aria-pressed', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-pressed', 'true');

  var gallery = card.querySelector('.feature-gallery');
  if(gallery){
    gallery.querySelectorAll('.gallery-set').forEach(function(g){ g.classList.remove('active'); });
    var targetSet = btn.dataset.target && document.getElementById(btn.dataset.target);
    if(targetSet) targetSet.classList.add('active');
  }
  var title = card.querySelector('.card-body h3');
  if(title && btn.dataset.title) title.textContent = btn.dataset.title;
  var accent = card.querySelector('[data-role="accent-value"]');
  if(accent && btn.dataset.accent) accent.textContent = btn.dataset.accent;

  var mode = btn.dataset.mode === 'overview' ? 'overview' : 'single';
  var details = card.querySelector('.product-details');
  var hint = card.querySelector('.overview-hint');
  if(details) details.hidden = (mode === 'overview');
  if(hint) hint.hidden = (mode !== 'overview');

  // Real add-to-cart wiring: a colour swatch (not the "Beide ansehen" button, which
  // carries no variant id) updates the hidden variant input, the shown price and the
  // submit button's label/disabled state, so "In den Warenkorb" always adds exactly the
  // colour (and, once a Größe option exists, colour+size) currently on screen. A card
  // with a size-picker can't be resolved from the colour button alone anymore, so that
  // case defers to the combined colour+size resolver instead.
  var sizePicker = card.querySelector('[data-role="size-picker"]');
  var variantsDataEl = card.querySelector('[data-role="variants-json"]');
  if(sizePicker || variantsDataEl){
    window.kaleaResolveKollektionVariant(card);
  } else if(btn.dataset.variantId){
    var variantInput = card.querySelector('[data-role="variant-id-input"]');
    if(variantInput) variantInput.value = btn.dataset.variantId;
    var priceEl = card.querySelector('[data-role="price-value"]');
    if(priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    var available = btn.dataset.available === 'true';
    var addBtn = card.querySelector('[data-role="add-submit"]');
    var addLabel = card.querySelector('[data-role="add-label"]');
    if(addBtn) addBtn.disabled = !available;
    if(addLabel) addLabel.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
    var availabilityBadge = card.querySelector('[data-role="availability-badge"]');
    if(availabilityBadge) availabilityBadge.textContent = available ? 'Limitierte Auflage' : 'Ausverkauft';
  }

  // Switching to "Alle ansehen" hides the whole .product-details box (price, specs,
  // buy button) and swaps in the much shorter overview grid, so the card shrinks a
  // lot. If the user had scrolled down inside the previous (taller) photo stack, that
  // same scroll position now lands well past the card entirely, stranding them on
  // unrelated content below (trust bar / banner). Scroll back up only when that's
  // actually happened, so a normal colour switch near the top never auto-scrolls.
  var headerEl = document.querySelector('header.main-nav');
  var scrollOffset = (headerEl ? headerEl.offsetHeight : 0) + 20;
  var cardRect = card.getBoundingClientRect();
  if(cardRect.bottom < scrollOffset){
    var cardY = cardRect.top + window.pageYOffset - scrollOffset;
    window.scrollTo({top: Math.max(0, cardY), left: 0, behavior: 'smooth'});
  }
};

// Größe-Picker (only rendered once a product has a second "Größe" option besides
// Farbe): clicking S/M doesn't touch the gallery/title, only which exact variant
// (colour + size together) is the one that gets added to the cart.
window.kaleaSelectSize = function(btn){
  if(!btn) return;
  var picker = btn.closest('[data-role="size-picker"]');
  var card = btn.closest('.card');
  if(!picker || !card) return;

  picker.querySelectorAll('.swatch-btn').forEach(function(b){
    b.classList.remove('active');
    b.setAttribute('aria-pressed', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-pressed', 'true');

  var sizeValue = card.querySelector('[data-role="size-value"]');
  if(sizeValue && btn.dataset.size) sizeValue.textContent = btn.dataset.size;

  window.kaleaResolveKollektionVariant(card);
};

// Looks up the exact variant matching the currently active colour swatch AND the
// currently active Größe button (from the embedded variants JSON, prices already
// pre-formatted server-side via the `money` filter) and updates the hidden variant
// id, shown price, availability badge and add-button state to match — the 2D
// counterpart to the direct per-button update above, used whenever a size-picker
// is present on the card.
window.kaleaResolveKollektionVariant = function(card){
  if(!card) return;
  var dataEl = card.querySelector('[data-role="variants-json"]');
  if(!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }

  var colorBtn = card.querySelector('.swatch-picker .swatch-btn.active[data-color]');
  var sizePicker = card.querySelector('[data-role="size-picker"]');
  var sizeBtn = sizePicker && sizePicker.querySelector('.swatch-btn.active');
  var color = colorBtn && colorBtn.dataset.color;
  var size = sizeBtn && sizeBtn.dataset.size;
  if(!color) return;

  // Personalisierung (optional, paid "Ohne"/"Mit Gravur" variant option, only present
  // once it's actually been added to the product in Shopify Admin) factors into which
  // exact variant — and therefore which price — matches, same as colour/size.
  var hasPersonalizeOption = variants.some(function(v){ return v.personalize; });
  var personalizeCheckbox = card.querySelector('.personalize-checkbox-input');
  var wantPersonalize = (personalizeCheckbox && personalizeCheckbox.checked) ? 'Mit Gravur' : 'Ohne';

  var addBtn = card.querySelector('[data-role="add-submit"]');
  var addLabel = card.querySelector('[data-role="add-label"]');
  var priceEl = card.querySelector('[data-role="price-value"]');

  // A size-picker exists but no size has been picked yet: still show a
  // representative price for the chosen colour (and personalize state), but
  // keep the button disabled and prompt for a size instead of guessing.
  if(sizePicker && !size){
    var repVariant = null;
    for(var j = 0; j < variants.length; j++){
      var rv = variants[j];
      if(rv.option1 === color && (!hasPersonalizeOption || rv.personalize === wantPersonalize)){ repVariant = rv; break; }
    }
    if(priceEl && repVariant) priceEl.textContent = repVariant.price;
    if(addBtn) addBtn.disabled = true;
    if(addLabel) addLabel.textContent = 'Größe wählen';
    return;
  }

  var match = null;
  for(var i = 0; i < variants.length; i++){
    var v = variants[i];
    if(v.option1 !== color) continue;
    if(size && v.option2 !== size) continue;
    if(hasPersonalizeOption && v.personalize !== wantPersonalize) continue;
    match = v;
    break;
  }
  if(!match) return;

  var variantInput = card.querySelector('[data-role="variant-id-input"]');
  if(variantInput) variantInput.value = match.id;
  if(priceEl) priceEl.textContent = match.price;
  if(addBtn) addBtn.disabled = !match.available;
  if(addLabel) addLabel.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
  var availabilityBadge = card.querySelector('[data-role="availability-badge"]');
  if(availabilityBadge) availabilityBadge.textContent = match.available ? 'Limitierte Auflage' : 'Ausverkauft';
};

// Personalisierung: ticking the checkbox reveals the name field (and makes it
// required so an empty name can't be submitted); the entered name travels to
// Shopify as a cart line item property (properties[Personalisierung - Name]),
// so it shows up automatically on the order in Shopify Admin. If the product also
// has a priced "Personalisierung: Ohne/Mit Gravur" variant option, checking the box
// re-resolves the variant too, so the surcharge shows up immediately in the price.
window.kaleaTogglePersonalizeField = function(checkbox){
  if(!checkbox) return;
  var wrap = checkbox.closest('.personalize-toggle');
  var field = wrap && wrap.querySelector('.personalize-field');
  if(!field) return;
  var input = field.querySelector('input');
  field.hidden = !checkbox.checked;
  if(input){
    input.required = checkbox.checked;
    if(!checkbox.checked) input.value = '';
  }
  // If Personalisierung carries its own price (a "Mit Gravur" variant), checking the
  // box has to re-resolve the variant/price exactly like a colour or size change.
  var card = checkbox.closest('.card');
  if(card) window.kaleaResolveKollektionVariant(card);
};

// Category pages (Halsbänder, Leinen, Accessoires, …): each filter — Farbe,
// Kollektion, Preis — is its own <select> dropdown marked with data-filter-group,
// living inside a shared ".kalea-filterable" wrapper alongside the ".cards" grid.
// Changing one dropdown narrows that filter only; all dropdowns combine with AND, so
// a card has to match every currently chosen value (not just the one just changed)
// to stay visible. Reused as-is by any page that follows this same markup pattern.
window.kaleaFilterCards = function(select){
  var wrapper = select.closest('.kalea-filterable');
  if(!wrapper) return;

  var activeFilters = {};
  wrapper.querySelectorAll('[data-filter-group]').forEach(function(s){
    activeFilters[s.dataset.filterGroup] = s.value;
  });

  wrapper.querySelectorAll('.cards .card').forEach(function(card){
    var show = true;
    Object.keys(activeFilters).forEach(function(key){
      var wanted = activeFilters[key];
      if(wanted !== 'alle' && card.dataset[key] !== wanted){ show = false; }
    });
    card.hidden = !show;
  });
};

// Real Shopify search — now that this runs on an actual store, hand-maintained keyword
// routing isn't needed any more: forward straight to Shopify's own search, which indexes
// products, pages and articles for us.
window.kaleaSearch = function(qRaw){
  var q = (qRaw || '').trim();
  if(!q) return;
  window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product,page,article';
};

// Full-screen search overlay: clicking the magnifying glass in the header opens a
// full-screen panel (in front of the header) with the Kalea wordmark and search field
// centred, plus popular searches and bestseller shortcuts underneath — instead of the
// old inline-expanding input.
// Scroll lock: plain "overflow:hidden" on body doesn't reliably stop background
// scrolling on iOS Safari, so while the overlay is open the body is pinned in place
// with position:fixed at its current scroll offset, then released back to that exact
// spot on close — this is what actually blocks scroll/rubber-banding on iPhone too.
var kaleaSearchOverlayScrollY = 0;
window.kaleaToggleSearchOverlay = function(force){
  var overlay = document.getElementById('searchOverlay');
  var btn = document.querySelector('.nav-search button');
  if(!overlay) return;
  var open = (typeof force === 'boolean') ? force : !overlay.classList.contains('open');
  overlay.classList.toggle('open', open);
  document.body.classList.toggle('search-overlay-open', open);
  if(open){
    kaleaSearchOverlayScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -kaleaSearchOverlayScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
  } else {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, kaleaSearchOverlayScrollY);
  }
  if(btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  if(open){
    var input = document.getElementById('searchOverlayInput');
    if(input){ setTimeout(function(){ input.focus(); }, 150); }
  }
};
// Close the overlay automatically when a link inside it is followed (popular search,
// bestseller tile, …) — matters most for a same-page anchor link (e.g. the Sunset/Ocean
// "#swatch-…" links when already on that page), which wouldn't otherwise trigger a full
// page reload to clear the overlay on its own.
(function(){
  var overlay = document.getElementById('searchOverlay');
  if(!overlay) return;
  overlay.addEventListener('click', function(e){
    if(e.target.closest('a')){ window.kaleaToggleSearchOverlay(false); }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ window.kaleaToggleSearchOverlay(false); }
  });
  // Click anywhere outside the dropdown (and outside the magnifying-glass button
  // that opens it) closes it again.
  document.addEventListener('click', function(e){
    if(!overlay.classList.contains('open')) return;
    if(overlay.contains(e.target)) return;
    var trigger = document.querySelector('.nav-search');
    if(trigger && trigger.contains(e.target)) return;
    var mobileTrigger = document.querySelector('.nav-search-mobile');
    if(mobileTrigger && mobileTrigger.contains(e.target)) return;
    window.kaleaToggleSearchOverlay(false);
  });
})();

// Mobile menu accordion: a category with sub-pages (Produkte, Material & Handwerk)
// only reveals its sub-links once its chevron is tapped, instead of listing
// everything flat right away. Tapping the link itself still navigates normally —
// only the separate chevron button expands/collapses.
window.kaleaToggleMobileSubmenu = function(btn){
  var group = btn.closest('.mobile-nav-group');
  var panel = group && group.querySelector('.mobile-nav-sub');
  if(!panel) return;
  var open = btn.getAttribute('aria-expanded') !== 'true';
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  panel.classList.toggle('open', open);
};

// Footer accordion (mobile only — CSS keeps the list always open above 760px, so
// this toggle has no visible effect on desktop even if triggered): Marke/Service/
// Folgen each reveal their links only once tapped, instead of listing everything
// flat right away.
window.kaleaToggleFooterSubmenu = function(btn){
  var col = btn.closest('.foot-col');
  var list = col && col.querySelector('.foot-col-list');
  if(!list) return;
  var open = btn.getAttribute('aria-expanded') !== 'true';
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  list.classList.toggle('open', open);
};

// Mobile menu: the hamburger button opens a full-screen drawer with every nav link listed
// flat (no hover needed, since hover doesn't exist on touch) plus search/cart/account.
window.kaleaToggleMobileNav = function(force){
  var drawer = document.getElementById('mobileNav');
  var btn = document.querySelector('.nav-hamburger');
  if(!drawer) return;
  var open = (typeof force === 'boolean') ? force : !drawer.classList.contains('open');
  drawer.classList.toggle('open', open);
  document.body.classList.toggle('mobile-nav-open', open);
  if(btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
};
// Close the drawer automatically when a link inside it is followed, and on Escape.
(function(){
  var drawer = document.getElementById('mobileNav');
  if(!drawer) return;
  drawer.addEventListener('click', function(e){
    if(e.target.tagName === 'A'){ window.kaleaToggleMobileNav(false); }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ window.kaleaToggleMobileNav(false); }
  });
})();

// Wordmark slide-up: on the homepage the big "Kalea." sits over the hero video; as you
// scroll it fades away and slides up, then the small wordmark in the sticky header
// fades/slides into place. No-op on any page without a hero stage. Runs on mobile too,
// same as desktop — only the hero's own aspect ratio differs there, which the height-
// based scroll math below already adapts to automatically.
(function(){
  var heroStage = document.querySelector('.hero-stage');
  var heroWord = document.querySelector('.hero-video-word');
  var navWord = document.querySelector('.nav-wordmark');
  if(!heroStage || !heroWord || !navWord) return;
  var ticking = false;
  function update(){
    var rect = heroStage.getBoundingClientRect();
    var heroHeight = heroStage.offsetHeight || 1;
    var scrolled = Math.min(Math.max(-rect.top, 0), heroHeight);
    var progress = scrolled / heroHeight;
    var heroLocal = Math.max(0, Math.min(1, progress / 0.42));
    var navLocal = Math.max(0, Math.min(1, (progress - 0.48) / 0.52));
    navWord.classList.toggle('nav-wordmark-hidden', navLocal <= 0);
    navWord.style.opacity = navLocal.toFixed(3);
    navWord.style.transform = 'translateY(' + (10 - 10 * navLocal).toFixed(2) + 'px)';
    heroWord.style.opacity = (1 - heroLocal).toFixed(3);
    heroWord.style.transform = 'translateY(' + (-36 * heroLocal).toFixed(2) + 'px) scale(' + (1 - 0.08 * heroLocal).toFixed(3) + ')';
    ticking = false;
  }
  function onScroll(){
    if(!ticking){ requestAnimationFrame(update); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  update();
})();

// Gewährleistungs-Hinweis modal: shows the EU legal-guarantee info graphic as
// a simple image lightbox — closes on the × button, a click on the dark
// backdrop, or Escape.
window.kaleaOpenGuaranteeModal = function(e){
  if(e) e.preventDefault();
  var modal = document.getElementById('guaranteeModal');
  if(!modal) return;
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
};
window.kaleaCloseGuaranteeModal = function(){
  var modal = document.getElementById('guaranteeModal');
  if(!modal) return;
  modal.classList.remove('open');
  document.body.style.overflow = '';
};
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){ window.kaleaCloseGuaranteeModal(); }
});

// Header cart icon: our own persistent bag icon lives outside the hidden
// #cart-icon-bubble twin Shopify's own cart-drawer.js repaints after every
// cart change (which otherwise silently swaps in Dawn's own thin icon). A
// MutationObserver mirrors that hidden element's real item count onto our
// visible number whenever it changes, no matter what triggered the change
// (add, remove, quantity edit) or which script performed it.
(function(){
  var hidden = document.getElementById('cart-icon-bubble');
  var visibleCount = document.querySelector('.kalea-cart-count-visible');
  if(!hidden || !visibleCount) return;
  var syncCount = function(){
    var badge = hidden.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    var text = badge ? badge.textContent.trim() : '';
    visibleCount.textContent = text;
    visibleCount.hidden = (text === '');
  };
  syncCount();
  new MutationObserver(syncCount).observe(hidden, {childList: true, subtree: true, characterData: true});
})();

// Our own click handler opens the drawer directly (instead of depending on
// Dawn's listener, which is attached to the now-hidden #cart-icon-bubble
// twin rather than the visible icon the customer actually clicks).
window.kaleaOpenCartDrawer = function(e){
  var drawer = document.querySelector('cart-drawer');
  if(!drawer || typeof drawer.open !== 'function') return;
  if(e) e.preventDefault();
  drawer.open(document.getElementById('cart-icon-bubble'));
};

// Dawn already toggles body.overflow-hidden while the cart drawer is open (it does
// this itself in cart-drawer.js, on every path that opens it — the header icon,
// add-to-cart auto-opening it, our own kaleaOpenCartDrawer above, …) and our own
// mobile nav drawer toggles body.mobile-nav-open the same way — but plain
// "overflow:hidden" on <body> doesn't reliably stop background touch-scrolling on
// iOS Safari — a well-known platform quirk. Watching both classes (instead of
// hooking every individual open/close call site) additionally pins the body in
// place with position:fixed while either is set, and restores the exact scroll
// position once both are removed.
(function(){
  var lockedScrollY = 0;
  var observer = new MutationObserver(function(){
    var shouldLock = document.body.classList.contains('overflow-hidden') || document.body.classList.contains('mobile-nav-open');
    var isLocked = document.body.style.position === 'fixed';
    if(shouldLock && !isLocked){
      lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = (-lockedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    } else if(!shouldLock && isLocked){
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, lockedScrollY);
    }
  });
  observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
})();
